import { Stack } from '@mui/system'
import React from 'react'
import { Link } from 'react-router-dom'
import logo from "../assets/images/Logo.png"
const Navbar = () => {
  return (
    <div>
      <Stack flexDirection={"row"} alignItems="center" sx={{ gap: { sm: '123px', xs: '40px' }, mt: { sm: '32px', xs: '20px' }, justifyContent: 'none' }} px="20px" >
        <Link to="/" >
          <img src={logo} alt="img" style={{width:"48px",height:"48px", margin:"0 20px"}} />
        </Link>
        <Stack flexDirection={"row"} gap="40px" fontSize={"24px"} alignItems="flex-end" >
          <Link to="/" style={{ textDecoration: "none", color: "#3A1212", borderBottom:"2px solid #FF2526"}}>Home  </Link>
          <a href="#exercises" style={{textDecoration:"none",color:"#3A1212"}}>Exercises</a>
        </Stack>
      </Stack>
    </div>
  )
}

export default Navbar
